import { Carousel, Slide } from 'vue-carousel'

export default {
  data: {
    reviews: [],
    review_analytic: '',
    mobileBreakPoint: 768,

    carousel: {
      review: { page_count: 0, first_page: false, last_page: false }
    }
  },

  components: {
    Carousel,
    Slide
  },

  methods: {
    bindData(data){
      this.reviews = data.reviews
      this.review_analytic = data.review_analytic
    },

    updateCarouselNav(type = 'review') {
      this.carousel[type].page_count = this.$refs[`${type}Carousel`].pageCount

      this.carousel[type].first_page = this.$refs[`${type}Carousel`].currentPage === 0

      this.carousel[type].last_page = this.$refs[`${type}Carousel`].currentPage === (
        this.$refs[`${type}Carousel`].pageCount - 1
      )
    },

    navCarousel(type = 'review', action = 'next') {
      if (action === 'prev')
        this.$refs[`${type}Carousel`].goToPage(
          this.$refs[`${type}Carousel`].getPreviousPage()
        )
      else
        this.$refs[`${type}Carousel`].goToPage(
          this.$refs[`${type}Carousel`].getNextPage()
        )

      this.updateCarouselNav(type)
    },

    mobileView() {
      const windowWidth = screen.width
      return (windowWidth < this.mobileBreakPoint)
    },

    initializeCarousel(data) {
      if(Kadenze.isKadenze){
        if (data.reviews.length)
          this.updateCarouselNav()
      }
    }
  },

  mounted() {
    this.initializeCarousel(this)
  }
}
